import { Card, CardContent, Typography, Chip, Button, Box } from "@mui/material";

export default function OfferCard({ offer }) {
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        boxShadow: 0,
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              {offer.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {offer.source} – {offer.type}
            </Typography>
          </Box>
          <Chip
            label={offer.badge}
            size="small"
            color={offer.badgeColor || "default"}
            sx={{ mt: 0.5 }}
          />
        </Box>

        <Typography variant="h6" fontWeight="bold" sx={{ color: offer.valueColor || "success.main" }}>
          {offer.value}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {offer.description}
        </Typography>

        {offer.expiration && (
          <Typography variant="caption" color="text.secondary">
            Expires in {offer.expiration} days
          </Typography>
        )}

        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
          <Button variant="contained" color="primary" size="small" sx={{ borderRadius: 2 }}>
            Apply Now
          </Button>
          <Button variant="outlined" color="primary" size="small" sx={{ borderRadius: 2 }}>
            Compare
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
